import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { trackPageview } from 'js/utils/tracking';
import HeaderRegionCharacters from 'js/containers/header-region/HeaderRegion.characters';
import { METADATA_CMS_IDS, PAGE_IDS } from 'js/constants/Pages';

// import svg
import SvgTextureLineLong from 'js/components/svg/Svg.texture_line_long';

// import components
import SiteMetaData from 'js/components/generic/Generic.metadata';
import ContentItemCharactersGrid from 'js/components/content-item/ContentItem.characters-grid';

// import
import { getSiteMetaData, getCurrentPageData } from '../store/app/App.selectors';
import { getAllCharacters } from 'js/store/characters/Characters.selectors';

const PageCharacters = (props) => {
  const meta = useSelector((state) => {
    return getSiteMetaData(state, METADATA_CMS_IDS[PAGE_IDS.characters]);
  });

  const pageData = useSelector((state) => {
    return getCurrentPageData(state, PAGE_IDS.characters);
  });

  const allCharacters = useSelector((state) => getAllCharacters(state));

  useEffect(() => {
    trackPageview({ title: 'meet the characters', path: props.path });
  }, []);

  const { header, promo = null, characters = null } = pageData;
  const { title = 'Meet the Characters', description = '' } = header || {};

  return (
    <>
      <SiteMetaData {...meta} />
      <HeaderRegionCharacters title={title} description={description} />
      <div className="characters-page__content-grid">
        <SvgTextureLineLong color={'#0092d4'} />
        <div className="container">
          <h3>Who lives in Porthole?</h3>
          <ContentItemCharactersGrid data={allCharacters} />
        </div>
      </div>
    </>
  );
};

export default PageCharacters;
